import React from "react";

const QueEsEneaCoaching = () => {
  return (
    <section className="section-container">
      <h2>ENEACOACHING</h2>
      <h3>¿QUÉ ES?</h3>
      <p>
        El EneaCoaching es un enfoque integral en el que combino el Coaching Ontológico con el Eneagrama para ayudar a las personas a alcanzar su máximo potencial, tanto en el ámbito personal como profesional. Este enfoque único integra la psicología del Eneagrama, que describe nueve tipos de personalidad, con las herramientas y técnicas del Coaching para facilitar un proceso de autoconocimiento, transformación y crecimiento.
      </p>

      <h3>¿Cómo funciona el EneaCoaching?</h3>
      <ul>
        <li>
          <strong>Autoconocimiento profundo:</strong> utilizando el Eneagrama, el EneaCoaching ayuda a identificar el tipo de personalidad de la persona y los patrones de pensamiento, emociones y comportamientos que la definen. Esto permite un entendimiento profundo de las motivaciones internas, fortalezas y áreas de mejora.
        </li>
        <li>
          <strong>Transformación y cambio:</strong> con base en el autoconocimiento, el EneaCoaching utiliza herramientas del Coaching Ontológico para transformar creencias limitantes, mejorar la toma de decisiones y fomentar un cambio significativo en la vida de la persona. El coaching se enfoca en el desarrollo de la persona, en su capacidad para generar nuevas posibilidades y alcanzar sus objetivos.
        </li>
        <li>
          <strong>Equilibrio de los centros de inteligencia:</strong> El EneaCoaching trabaja con los tres centros de inteligencia (cerebro, corazón e instinto), buscando un equilibrio integral que permita a la persona tomar decisiones alineadas con sus valores, emociones y cuerpo.
        </li>
        <li>
          <strong>Alineación con el propósito (Ikigai):</strong> En el proceso de EneaCoaching se incorpora el concepto de Ikigai, el propósito de vida, ayudando a la persona a encontrar una dirección clara y significativa en su vida, tanto a nivel personal como profesional.
        </li>
      </ul>

      <h3>¿Qué beneficios ofrece el EneaCoaching?</h3>
      <ul>
        <li>Autoconocimiento profundo y revelador: al identificar tu tipo de personalidad según el Eneagrama, podrás comprender tus comportamientos, emociones y motivaciones subyacentes, lo que te permitirá tomar decisiones más conscientes.</li>
        <li>Mayor claridad en objetivos y propósito: con las herramientas de Coaching, podrás definir metas claras y alineadas con tu propósito de vida.</li>
        <li>Desarrollo personal integral: El EneaCoaching te permite trabajar en todos los aspectos de tu ser, ayudando a mejorar la gestión emocional, la toma de decisiones, las relaciones interpersonales y la productividad.</li>
        <li>Mayor bienestar y equilibrio: A través del trabajo con los tres centros de inteligencia, lograrás un equilibrio que te permitirá sentirte más centrado y en paz.</li>
      </ul>

      <p>
        En resumen, el EneaCoaching es un proceso de acompañamiento único que no solo te ayuda a alcanzar metas concretas, sino que también transforma tu manera de ser y estar en el mundo, alineándote con tu verdadero propósito.
      </p>
    </section>
  );
};

export default QueEsEneaCoaching;
